/**
 * Q36 (T387 M6) — the soft typo-guard thresholds for STANDING-price writes
 * (rate edits, add-entry, promote, add-on prices). Client-side warn-once
 * only, NEVER a server refusal: Captain confirmed the deferral of any hard
 * bound at the T374 plan gate; the server's only ceiling is the M2
 * MAX_MONEY_CENTS sanity cap (€100k).
 *
 * - Where an OLD price exists: 10x in either direction (the shipped
 *   override mechanic, Quote.tsx — a true order-of-magnitude slip).
 * - New entries have no old price: an absolute ceiling. €2,000 clears every
 *   real standing price on file (the dearest is in the hundreds) by a wide
 *   margin while catching the classic missing-decimal typo (4800 for 480).
 */
export const Q36_NEW_ENTRY_CEILING_CENTS = 200_000;

/** True when a changed price is an order of magnitude off the old one. */
export function q36MagnitudeSlip(newCents: number, oldCents: number | null): boolean {
  if (oldCents == null || oldCents <= 0) return newCents > Q36_NEW_ENTRY_CEILING_CENTS;
  return newCents > 10 * oldCents || newCents * 10 < oldCents;
}
